import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "src/components/ui/alert-dialog";
import { useToast } from "src/components/ui/toast";
import { useDeleteContact } from "../hooks/useContacts";

export function DeleteContactModal({ open, onClose, contact, onSuccess }) {
  const { toast } = useToast();
  const deleteHook = useDeleteContact();

  async function handleConfirm(e) {
    e.preventDefault();
    if (!contact) return;
    
    try {
      await deleteHook.mutate(contact.id);
      toast({ title: "Contact deleted" });
      onSuccess?.();
      onClose();
    } catch (err) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to delete contact.",
      });
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete the
            contact "{contact?.name}" and remove their data from our servers.
            Any linked properties or requirements may also be affected.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteHook.isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={deleteHook.isPending}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {deleteHook.isPending ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
